import React, { Fragment, useState, useRef } from 'react'
import { Tabs, Row, Col } from 'antd'
import DocumentManagement from '../DocumentManagement'
import NewHeader from '../../../../components/NewHeader'
import { useTranslation } from 'react-i18next'
import { general } from '../../../../constants'
import { useEffect } from 'react'
import { api } from '../../../../services'
import { useSelector } from 'react-redux'

const { TabPane } = Tabs

const List_ = () => {
  const { t } = useTranslation()

  const isKnowledgeCenter = window.location.pathname.includes(
    '/knowledge-center'
  )

  const [activeKey, setActiveKey] = useState('')
  const [orgUserList, setOrgUsers] = useState([])

  useEffect(() => {
    const initialKey = isKnowledgeCenter
      ? general.ORGANIZATION_LIBRARY
      : general.MY_MEDIA

    setActiveKey(initialKey)
  }, [])

  // Add refs for each DocumentManagement
  const myRef = useRef()
  const orgRef = useRef()
  const publicRef = useRef()
  const downloadsRef = useRef()

  const queryMap = {
    my: { isActiveOrg: true },
    org: { isOrg: true },
    public: { isPublic: true },
    downloads: { isDownload: true }
  }

  // Refetch on tab change
  const handleTabChange = key => {
    setActiveKey(key)
    if (key === general.MY_MEDIA) {
      if (myRef.current) myRef.current.refetch()
    } else if (key === general.ORGANIZATION_LIBRARY) {
      if (orgRef.current) orgRef.current.refetch()
    } else if (key === general.PUBLIC_MEDIA) {
      if (publicRef.current) publicRef.current.refetch()
    } else if (key === general.DOWNLOADS_CENTER) {
      if (downloadsRef.current) downloadsRef.current.refetch()
    }
  }
  const user = useSelector(state => state.user)
  const activeOrganizationId =
    user && user.info && user.info.organization && user.info.organization.id

  useEffect(() => {
    let isMounted = true

    const fetchOrgUsers = async () => {
      if (activeOrganizationId) {
        try {
          let res = await api.organizations.getUsersByOrganizationId(
            activeOrganizationId
          )
          if (isMounted) {
            setOrgUsers(res.data || [])
          }
        } catch (error) {
          console.error('Error fetching organization users:', error)
          if (isMounted) {
            setOrgUsers([])
          }
        }
      }
    }

    fetchOrgUsers()

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false
    }
  }, [activeOrganizationId])
  return (
    <Fragment>
      <section className="section">
        <Row>
          <Col span={12}>
            <div className="head">
              <div className="head__title">{t('media:title')}</div>
              <div className="head__description">{t('media:subtitle')}</div>
            </div>
          </Col>
          <Col span={12}>
            <NewHeader />
          </Col>
        </Row>
      </section>
      <section className="document-management-section">
        <Tabs
          animated={false}
          activeKey={activeKey}
          onChange={handleTabChange}
          className="document-tabs"
        >
          {!isKnowledgeCenter && (
            <TabPane
              tab={t('media:my_media')}
              key={general.MY_MEDIA}
              hidden={isKnowledgeCenter}
            >
              <DocumentManagement
                orgUserList={orgUserList}
                t={t}
                ref={myRef}
                defaultQuery={queryMap.my}
                tab={general.MY_MEDIA}
              />
            </TabPane>
          )}
          {activeOrganizationId && (
            <TabPane
              tab={t('media:organization_library')}
              key={general.ORGANIZATION_LIBRARY}
            >
              <DocumentManagement
                orgUserList={orgUserList}
                t={t}
                ref={orgRef}
                defaultQuery={queryMap.org}
                tab={general.ORGANIZATION_LIBRARY}
              />
            </TabPane>
          )}
          {!isKnowledgeCenter && (
            <TabPane
              tab={t('media:public_library')}
              key={general.PUBLIC_MEDIA}
              hidden={isKnowledgeCenter}
            >
              <DocumentManagement
                orgUserList={orgUserList}
                t={t}
                ref={publicRef}
                defaultQuery={queryMap.public}
                tab={general.PUBLIC_MEDIA}
              />
            </TabPane>
          )}
          {activeOrganizationId && (
            <TabPane
              tab={t('v4:downloads_center')}
              key={general.DOWNLOADS_CENTER}
            >
              <DocumentManagement
                orgUserList={orgUserList}
                t={t}
                ref={downloadsRef}
                tab={general.DOWNLOADS_CENTER}
                defaultQuery={queryMap.downloads}
              />
            </TabPane>
          )}
        </Tabs>
      </section>
    </Fragment>
  )
}

export default List_
